import {apiGetCall, apiPostCall} from "./index";

export const load   = () => apiGetCall("/affiliates/getall");
export const save   = (uuid, affiliateDetails) => apiPostCall("/affiliates/save", {uuid, ...affiliateDetails});
export const remove = uuid => apiPostCall("/affiliates/remove", {uuid});